import { render, staticRenderFns } from "./PluginUblSettingsPeppol.vue?vue&type=template&id=6ed792fe"
import script from "./PluginUblSettingsPeppol.vue?vue&type=script&lang=ts"
export * from "./PluginUblSettingsPeppol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed792fe')) {
      api.createRecord('6ed792fe', component.options)
    } else {
      api.reload('6ed792fe', component.options)
    }
    module.hot.accept("./PluginUblSettingsPeppol.vue?vue&type=template&id=6ed792fe", function () {
      api.rerender('6ed792fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/PluginUblSettingsPeppol.vue"
export default component.exports